<template>
  <div id="app">
    <loading></loading>
    <router-view class="xiaobu-app-container" />
  </div>
</template>

<script>
import Loading from "@/components/loading"
export default {
  name: "App",
  components: {
    Loading
  },
  created() {
    // iframe通信
    this.iframeConnect()
  },
  methods: {
    // iframe通信
    iframeConnect() {
      const _this = this
      // 监听子页面想父页面的传参
      window.addEventListener("message", function(event) {
        //此处执行事件
        // 通过origin对消息进行过滤，避免遭到XSS攻击  可通过全局配置接口获取 域名白名单 进行判断 也可写死
        if (event.origin === "https://www.xiaobu.host") {
          if (event.data && event.data.action === "$router") {
            _this.$router[event.data.loadData.funcName](event.data.loadData.funcItem)
            return
          }

          if (event.data && event.data.action === "logout") {
            // 重新登录方法   弹框提示 点击确认后 建议清除 缓存中token等信息后 刷新页面
            _this.$modal.alertWarning("确认退出登录？").then(() => {
              _this.$store.dispatch("user/logout").then(() => {
                _this.$modal.msgSuccess("退出登录成功")
                _this.$router.push(`/login`)
              })
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  .xiaobu-app-container {
    width: 100%;
    height: 100%;
  }
}
</style>
